/* ----------------- Hooks --------------- */
import { useAppTheme } from "../../../useAppTheme";
import { useDevice } from "../../../useDevice";

/* ----------------- Components --------------- */
import Box from "../../Box";

/* ----------------- External Libraries --------------- */
import ContentLoader from "react-native-easy-content-loader";

export const StatsSkeleton = ({
	numRows = 3,
	isSmallScreen,
}: {
	numRows?: number;
	isSmallScreen?: boolean;
}) => {
	const { isMobile } = useDevice();

	const theme = useAppTheme();
	return (
		<Box
			flexDirection="row"
			gap={8}
			alignItems="center"
			flexGrow={1}
			justifyContent={"space-around"}
			maxWidth={isMobile ? "100%" : 350}
		>
			{[...new Array(numRows).keys()].map((item) => {
				return (
					<Box
						gap={4}
						key={item}
						alignItems="center"
						borderWidth={0}
						borderColor={theme.colors.outlineVariant}
						// borderRadius={12}
						padding={isSmallScreen ? 0 : 8}
						flexGrow={1}
					>
						{/*@ts-ignore */}
						<ContentLoader
							pRows={numRows}
							title={false}
							pWidth={[15, 17, 35]}
							pHeight={[11, 6, 6]}
							key={item}
							paragraphStyles={{
								alignSelf: "center",
							}}
						/>
					</Box>
				);
			})}
		</Box>
	);
};
